module.exports = __webpack_public_path__ + "img/app-rmbooking.4efaf6a8.png";